<div class="wrapper-container" [ngClass]="severity.toLowerCase()">
    <div class="wrapper-content">
        <ng-content></ng-content>
    </div>
</div>